<template>
	<BaseLayout :footer-full="true" :content-full-height="true" background-color-class="bg-color-white">
		<div class="container">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md">
					<h2 class="heading-2 mb-100">Contact the Connect API team</h2>
					<p class="mb-25"
						>Get in touch with our team to learn more about the Fundrise Connect API or to gain access to
						our Sandbox.</p
					>
					<h5 v-if="!hasSubmitted" class="heading-5 mt-200 mb-100">Email us</h5>
					<ContactUsForm :is-connect-api="true" @submit-success="hasSubmitted = true" />
				</div>
			</div>
		</div>
	</BaseLayout>
</template>
<script setup lang="ts">
import ContactUsForm from '@components/contact/contact-us-form.vue';
import { ref } from 'vue';
import { useHead } from '@unhead/vue';

const hasSubmitted = ref(false);

function setup(): void {
	useHead({
		title: 'Connect API - Contact Us'
	});
}

setup();
</script>
